import React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import {
  AssembleiaAssessor,
  AssembleiaAssociado,
  AssessorArea,
  AssociadoArea,
  EditarVotos,
  Error404,
  Home,
  HomeAssessor,
  HomeAssociado,
  ListagemCadastros,
  Manutencao,
  MensagensAssessor,
  Parametros,
  ProximosEventos,
  Quorum,
  RelatorioPresentes,
  Relatory,
  TransmissaoAssessor,
  VinculoAssociado,
  VotoPresencial,
  Wrapper,
} from 'pages';
import CookiePolicy from 'pages/cookiePolicy/cookiePolicy';
import PrivacyPolicy from 'pages/privacyPolicy/privacyPolicy';

export interface IRoute {
  path?: string | string[];
  component?:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
  exact?: boolean;
  render?: (props: RouteComponentProps<any>) => React.ReactNode;
}

export const basePath = '/assembleias/';

export const AssessorRoutePath = '/plataforma/assembleias';
export const AssociadoRoutePath = `${basePath}associado`;
export const cpfAnchorRoutePath = `${basePath}calendario/`;
export const PrivacyPolicyRoutePath = `${basePath}politica-privacidade`;

// Opened ROUTES
export const MainRoutePath = basePath;
const openedRoutes: IRoute[] = [
  {
    path: [MainRoutePath, cpfAnchorRoutePath],
    component: Home,
    exact: true,
  },
  {
    path: `${basePath}manutencao`,
    component: Manutencao,
    exact: true,
  },
  {
    path: PrivacyPolicyRoutePath,
    component: PrivacyPolicy,
    exact: true,
  },
  {
    path: `${basePath}politica-privacidade/politica-cookies`,
    component: CookiePolicy,
    exact: true,
  },
  {
    component: Error404,
  },
];

// Assessor ROUTES
export const AssembleiaAssessorRoutePath = `${AssessorRoutePath}/evento/:id`;
export const LiberarPautaEmLoteAssessorRoutePath = `${AssembleiaAssessorRoutePath}/liberar-pautas`;
export const VerificarInconsistenciaAssessorRoutePath = `${AssembleiaAssessorRoutePath}/verificar-inconsistencias/:idPauta`;
export const VotacaoPresencialRoutePath = `${AssembleiaAssessorRoutePath}/votacao-presencial`;
export const ReordenarPautasRoutePath = `${AssembleiaAssessorRoutePath}/reordenar-pautas`;
export const AssessorTransmissaoRoutePath = `${AssessorRoutePath}/transmissao`;
export const AssessorCadastroEventoRoutePath = `${AssessorRoutePath}/cadastro/`;
export const AssessorCadastroReuniaoRoutePath = `${AssessorRoutePath}/reuniao/cadastro/`;
export const AssessorEditarVotosRoutePath = `${AssessorRoutePath}/evento/:id/editar-votos`;
export const RelatorioPresentesRoutePath = `${AssessorRoutePath}/evento/:idAssembleia/presentes`;
export const QuorumRoutePath = `${AssessorRoutePath}/evento/:idAssembleia/quorum`;
export const VotoPresencialPath = `${AssessorRoutePath}/evento/:idAssembleia/votopresencial`;
export const ListagemCadastrosPath = `${AssessorRoutePath}/associadoscadastrados`;
export const VinculoAssociadoPath = `${AssessorRoutePath}/associados`;
export const MensagensAssessorRoutePath = `${AssessorRoutePath}/evento/:idEvento/mensagens`;
export const ParametrosRoutePath = `${AssessorRoutePath}/parametros`;
export const AssessorRelatoriosRoutePath = `${AssessorRoutePath}/evento/:id/relatorios`;

const assessorRoutes: IRoute[] = [
  {
    path: AssessorRoutePath,
    component: HomeAssessor,
    exact: true,
  },
  {
    path: AssessorTransmissaoRoutePath,
    component: TransmissaoAssessor,
    exact: true,
  },
  {
    path: `${AssessorCadastroEventoRoutePath}:id?/etapas/:etapa?`,
    component: Wrapper,
    exact: true,
  },
  {
    path: `${AssessorCadastroReuniaoRoutePath}:id?/etapas/:etapa?`,
    component: Wrapper,
    exact: true,
  },
  {
    path: AssessorEditarVotosRoutePath,
    component: EditarVotos,
    exact: true,
  },
  {
    path: AssessorRelatoriosRoutePath,
    component: Relatory,
    exact: true,
  },
  {
    path: RelatorioPresentesRoutePath,
    component: RelatorioPresentes,
    exact: true,
  },
  {
    path: [
      AssembleiaAssessorRoutePath,
      LiberarPautaEmLoteAssessorRoutePath,
      VerificarInconsistenciaAssessorRoutePath,
      ReordenarPautasRoutePath,
      VotacaoPresencialRoutePath,
    ],
    component: AssembleiaAssessor,
    exact: true,
  },
  {
    path: QuorumRoutePath,
    component: Quorum,
    exact: true,
  },
  {
    path: VotoPresencialPath,
    component: VotoPresencial,
    exact: true,
  },
  {
    path: ListagemCadastrosPath,
    component: ListagemCadastros,
    exact: true,
  },
  {
    path: VinculoAssociadoPath,
    component: VinculoAssociado,
    exact: true,
  },
  {
    path: MensagensAssessorRoutePath,
    component: MensagensAssessor,
    exact: true,
  },
  {
    path: ParametrosRoutePath,
    component: Parametros,
    exact: true,
  },
];

// Associado ROUTES
export const AssociadoAssembleiaPath = `${AssociadoRoutePath}/assembleia/:id`;
export const ProximosEventosPath = `${AssociadoRoutePath}/proximoseventos`;

const associadoRoutes: IRoute[] = [
  {
    path: AssociadoRoutePath,
    component: HomeAssociado,
    exact: true,
  },
  {
    path: AssociadoAssembleiaPath,
    component: AssembleiaAssociado,
    exact: true,
  },
  {
    path: ProximosEventosPath,
    component: ProximosEventos,
    exact: true,
  },
];

export default function Routes() {
  return (
    <Switch>
      {/* Redirections from old to new routes */}
      <Redirect
        from='/plataforma/assembleias/:id?/editar-votos'
        to={AssessorEditarVotosRoutePath}
        exact
      />
      <Redirect
        from='/plataforma/assembleias/presentes/:idAssembleia'
        to={RelatorioPresentesRoutePath}
        exact
      />
      <Redirect
        from='/plataforma/assembleias/associados'
        to={VinculoAssociadoPath}
        exact
      />
      <Redirect
        from='/plataforma/assembleias/mensagens/:idEvento'
        to={MensagensAssessorRoutePath}
        exact
      />
      <Redirect
        from='/plataforma/assembleias/:id?/relatorios'
        to={AssessorRelatoriosRoutePath}
        exact
      />
      <Redirect from={`${basePath}assessor/`} to={AssessorRoutePath} exact />
      <Redirect
        from={`${basePath}assessor/assembleia/:id`}
        to={AssembleiaAssessorRoutePath}
        exact
      />

      <Route path={AssessorRoutePath}>
        <AssessorArea>
          {assessorRoutes.map((route, index) => (
            <Route {...route} key={`assessor_${index}`} />
          ))}
        </AssessorArea>
      </Route>
      <Route path={AssociadoRoutePath}>
        <AssociadoArea>
          {associadoRoutes.map((route, index) => (
            <Route {...route} key={`associado_${index}`} />
          ))}
        </AssociadoArea>
      </Route>
      <Route path={MainRoutePath}>
        <Switch>
          {openedRoutes.map((route, index) => (
            <Route {...route} key={`opened_${index}`} />
          ))}
        </Switch>
      </Route>
    </Switch>
  );
}
